<section class="card mb-3">
  <div class="card-header">
    <h3 class="card-title">
      {{ 'general.messages' | translate }}
    </h3>
  </div>
  <div class="card-body">
    <div class="col-md-6 m-auto">
      <div class="text-center" *ngIf="isLoading$ | async">
        <div
          class="spinner-border"
          role="status"
          attr.aria-label="{{ 'general.loading' | translate }}"
        >
        </div>
      </div>

      <ng-container *ngIf="!(isLoading$ | async)">
        <div
          *ngFor="let message of messages$ | async"
          class="d-flex flex-column mb-3"
          [ngClass]="{
            'align-items-end': !isFrontendUserTheSender(message, serieProposal),
            'align-items-start': isFrontendUserTheSender(message, serieProposal)
          }"
        >
          <small
            *ngIf="isFrontendUserTheSender(message, serieProposal)"
            class="text-muted align-self-start"
          >
            {{ (memberEntities$ | async)[message.senderPersonId]?.firstName }}
            {{ (memberEntities$ | async)[message.senderPersonId]?.lastName }}
          </small>

          <!-- Message bubble -->
          <div
            [ngClass]="{
              'bg-soft-secondary rounded-start-4': !isFrontendUserTheSender(
                message,
                serieProposal
              ),
              'bg-soft-primary rounded-end-4': isFrontendUserTheSender(
                message,
                serieProposal
              )
            }"
            class="rounded-top-4 text-dark p-2 px-3"
            style="max-width: 80%"
          >
            <p class="mb-1"> {{ message.message }} </p>
            <div class="text-end text-muted small">
              {{ message.datePosted | date : 'MMM dd yyyy, HH:mm' }}
            </div>
          </div>
        </div>
      </ng-container>

      <label class="form-label">
        {{ 'serieProposalModule.sendMessage' | translate }}
      </label>
      <textarea
        class="form-control mb-3"
        [(ngModel)]="newMessage"
        placeholder=" {{ 'serieProposalModule.newMessage' | translate }}"
        rows="3"
      ></textarea>
      <button
        [canSee]="[accessRights.SerieProposal_write]"
        class="btn btn-primary align-self-end"
        (click)="sendMessage()"
        type="button"
      >
        {{ 'general.send' | translate }}
      </button>
    </div>
  </div>
</section>
